$(document).ready(function(){
  $('.featured-collection-section .grid-product__slider').slick({
    infinite: true,
    arrows: false,
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
  
  $('.featured-collection-section .section-header__arrows .arrow-right').click(function(){
    $(".featured-collection-section .grid-product__slider").slick('slickNext');
  });
  $('.featured-collection-section .section-header__arrows .arrow-left').click(function(){
    $(".featured-collection-section .grid-product__slider").slick('slickPrev');
  });
});

function filterTemplateBlocks(e) {
    var searchText = e.target.value.toLowerCase();
    console.log('------- search test:', searchText);
    $('.ingredient').each(function() {
      var htmlText = $(this).find(".h3").html().toLowerCase();
      console.log(htmlText);
      if (htmlText.indexOf(searchText) < 0) {
        $(this).addClass('hidden');
      } else {
        $(this).removeClass('hidden');
      }
    });
  }

  function sortTemplateBlocks(e) {
    var sort = e.target.value;

    var items = $('.ingredient');
    
    
    if (sort === 'alphabet_asc') {
       items.sort(function(a, b){
         return $(a).find('div.h3').html() > $(b).find('div.h3').html() ? 1 : -1;
       });
    } else {
       items.sort(function(a, b){
         return $(a).find('div.h3').html() < $(b).find('div.h3').html() ? 1 : -1;
       });
    }
    
    items.appendTo('.ingredients-section .grid');
  }